export default __webpack_public_path__ + "static/media/selenium.7dcf1c14.svg";